var n = Object.freeze, b = Object.defineProperty;
var o = (t, e) => n(b(t, "raw", { value: n(e || t.slice()) }));
import { i as v, x as w } from "./lit-element-CwWchyls.js";
import { n as u } from "./property-EvzlnPW3.js";
import { e as f } from "./query-Dk6NwgU8.js";
import { L as k } from "./lds-form-element-SiTAij9m.js";
var h;
const m = v(h || (h = o(["\n    :host {\n        display: inline-block;\n        position: relative;\n        cursor: pointer;\n        --width: 36px;\n    }\n    label {\n        cursor: pointer;\n    }\n    input {\n        position: absolute;\n        width: 1px;\n        height: 1px;\n        padding: 0;\n        margin: -1px;\n        overflow: hidden;\n        clip: rect(0, 0, 0, 0);\n        border: 0;\n    }\n    .toggle-switch {\n        position: relative;\n        width: var(--width);\n        height: 18px;\n        background: var(--lds-switch-bg);\n        border-radius: 999px;\n        transition: background 0.3s ease;\n        border: 2px solid var(--lds-switch-border-color);\n    }\n    .toggle-switch.dot {\n        width: var(--lds-switch-dot-size);\n        height: var(--lds-switch-dot-size);\n        background: var(--lds-switch-dot-bg);\n        border-radius: 50%;\n        transition: translate 0.3s ease;\n        left: var(--lds-switch-dot-spacing);\n        border-color: var(--lds-switch-dot-border-color);\n        position: absolute;\n        top: 50%;\n        transform: translateY(-50%);\n    }\n\n    :host([checked]) .toggle-switch {\n        background: var(--lds-switch-active-bg);\n        border: 2px solid var(--lds-switch-active-border-color);\n    }\n    :host([checked]) .toggle-switch.dot {\n        background: var(--lds-switch-active-dot-bg);\n        border: 2px solid var(--lds-switch-active-dot-border-color);\n        translate: calc((var(--width) / 2) - var(--lds-switch-dot-spacing));\n    }\n\n    input:focus-visible ~ .toggle-switch {\n        outline: 3px solid black;\n    }\n"])));
var x = Object.defineProperty, d = (t, e, l, E) => {
  for (var r = void 0, s = t.length - 1, a; s >= 0; s--)
    (a = t[s]) && (r = a(e, l, r) || r);
  return r && x(e, l, r), r;
}, p;
const c = class c extends k {
  constructor() {
    super(...arguments), this.required = !1, this.checked = !1;
  }
  get validationElement() {
    return this.input;
  }
  onInputKeyUp(e) {
    e.key === "Enter" && this.onClick();
  }
  firstUpdated() {
    this.addEventListener("click", this.onClick);
  }
  onLabelClick(e) {
    e.preventDefault();
  }
  render() {
    return w(p || (p = o(['\n            <label for="input" part="label" @click=', '>\n                <slot></slot>\n            </label>\n            <input\n                part="input"\n                id="input"\n                @keyup=', '\n                type="checkbox"\n                role="switch"\n                aria-checked=', "\n                aria-required=", "\n                ?checked=", "\n                ?required=", ' />\n            <div class="toggle-switch" part="switch">\n                <div class="toggle-switch dot" part="dot"></div>\n            </div>\n        '])), this.onLabelClick, this.onInputKeyUp, this.checked, this.required, this.checked, this.required);
  }
  onClick() {
    this.checked = !this.checked, this.emit("change");
  }
};
c.styles = m;
let i = c;
d([
  u({ type: Boolean, reflect: !0 })
], i.prototype, "required");
d([
  u({ type: Boolean, reflect: !0 })
], i.prototype, "checked");
d([
  f("input")
], i.prototype, "input");
const g = new URL(import.meta.url), y = g.searchParams.has("debug");
if (!g.searchParams.has("no-define")) {
  const t = customElements.get("lds-switch");
  t ? t.VERSION !== i.VERSION && y && console.log("%clds-switch tried loading in version ".concat(i.VERSION, ", but lds-switch is already defined as ").concat(t.VERSION), "font-weight: bold; font-size: 16px; color: red;") : customElements.define("lds-switch", i);
}
export {
  i as LdsSwitch
};
